import React from "react";

import { RetailLocator } from "./RetailLocator";
import { SurveyModal } from "./SurveyModal";

// The retail-locator app's actual render. Loaded only on the client (via the
// StoreLocatorForm block's React.lazy import) because the locator app is
// client-only (Google Maps + Redux-driven UI). The reactivated renderer + the
// client entry already wrap the document in the Redux Provider, so no Provider
// is needed here. The ErrorBoundary lives in StoreLocatorForm (wrapping
// Suspense) so it also catches chunk-load failures of this lazy module.
const StoreLocatorAppInner = (): React.JSX.Element => (
    <>
        <RetailLocator />
        <SurveyModal />
    </>
);

export default StoreLocatorAppInner;
